import { render, staticRenderFns } from "./OrderedSelect.vue?vue&type=template&id=b20bc218&scoped=true&"
import script from "./OrderedSelect.vue?vue&type=script&lang=js&"
export * from "./OrderedSelect.vue?vue&type=script&lang=js&"
import style0 from "./OrderedSelect.vue?vue&type=style&index=0&id=b20bc218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20bc218",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VIcon,VSelect})
